import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuickEventForm from '../../../components/forms/QuickEventForm';
import { useQuickEventApi } from '../../../hooks/useQuickEventApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { QuickEventDTO } from '../../../services/apiClient';

const QuickEventCreate: React.FC = () => {
  const { create, isLoading } = useQuickEventApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Quick Events', href: '/admin/quickevents' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: QuickEventDTO) => {
    try {
      await create(data);
      navigate('/admin/quickevents');
    } catch (error) {
      console.error('Error creating QuickEvent:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/quickevents"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.QuickEvent.Edit'
    >
        <QuickEventForm
          initialValues={{} as QuickEventDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/quickevents')}
        />
    </AdminLayout>
  );
};

export default QuickEventCreate;